import { useState } from "react";
import PrinterPageView from "./PrinterPageView";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import useCustomEffect from "../../../hooks/useCustomEffect";
import { useParams } from "react-router-dom";
import { mapResponseTranslations } from "../../../hooks/useEntityTranslations";

function PrinterPage() {
  const callEvaApi = useEvaApi();
  const { printer } = useParams();
  const [fields, setFields] = useState([]);
  const [images, setImages] = useState([]);
  const [printerDevices, setPrinterDevices] = useState([]);
  const [printerData, setPrinterData] = useState({
    name: "",
    url: "",
    dpi: 300,
    rotate: false,
    label_width: 76.2,
    label_height: 50.7,
    label_items: [],
  });
  const [submitError, setSubmitError] = useState(null);

  /**
   * UseEffect for initializations and cleanup
   */
  useCustomEffect(() => {
    fetchFields();
    fetchImages();
    fetchPrinterDevices();

    if (printer) {
      fetchPrinterData();
    }
  });

  /**
   * This method will fetch the printer data from the API.
   */
  async function fetchPrinterData() {
    await callEvaApi(
      new EvaApiCall(`printers/${printer}`)
        .setLoadingGroup("printer_page_fetch")
        .setParams({
          with_printer_label_items_data: true,
        })
        .setOnSuccess((response) => {
          const data = response.data.data;
          setPrinterData({
            name: data.name,
            printer_device_id: data.printer_device_id,
            url: data.url,
            dpi: data.dpi,
            rotate: data.rotate,
            label_width: data.label_width,
            label_height: data.label_height,
            label_items: data.label_items.map((item) => ({
              id: item.id,
              type: item.type,
              position: item.position,
              width: item.width,
              height: item.height,
              font_size: item.font_size,
              font_weight: item.font_weight,
              text_align: item.text_align,
              field_id: item.field,
              image_id: item.image,
              translations: mapResponseTranslations(
                item.translations,
                (trans) => ({
                  text: trans.text,
                }),
              ),
              fields: item.fields,
            })),
          });
        })
        .setRedirectOnError(true),
    );
  }

  /**
   * This method will fetch the fields from the API.
   */
  async function fetchFields() {
    await callEvaApi(
      new EvaApiCall("fields")
        .setLoadingGroup("printer_page_fetch")
        .setOnSuccess((response) => {
          setFields(response.data.data.records);
        })
        .setRedirectOnError(true),
    );
  }

  /**
   * This method will fetch the images from the API.
   */
  async function fetchImages() {
    await callEvaApi(
      new EvaApiCall("files")
        .setLoadingGroup("printer_page_fetch")
        .setParams({
          where: [{ column: "type", values: ["image"] }],
        })
        .setOnSuccess((response) => {
          setImages(response.data.data.records);
        })
        .setRedirectOnError(true),
    );
  }

  /**
   * This method will fetch the printer devices from the API.
   */
  async function fetchPrinterDevices() {
    await callEvaApi(
      new EvaApiCall("printer_devices")
        .setLoadingGroup("printer_page_fetch")
        .setOnSuccess((response) => {
          setPrinterDevices(response.data.data.printers);
        })
        .setRedirectOnError(true),
    );
  }

  return (
    <PrinterPageView
      printerData={printerData}
      setPrinterData={setPrinterData}
      images={images}
      fields={fields}
      printerDevices={printerDevices}
      submitError={submitError}
      setSubmitError={setSubmitError}
    />
  );
}

export default PrinterPage;
